(function() {
  'use strict';

  function getConfig() {
    const scriptTag = document.querySelector('script[data-inventory-config]');
    if (scriptTag) {
      try {
        return JSON.parse(scriptTag.getAttribute('data-inventory-config'));
      } catch (e) {
        console.error('Failed to parse inventory config:', e);
      }
    }
    
    if (window.inventoryApiToken && window.productHandle) {
      return {
        storefrontAccessToken: window.inventoryApiToken,
        handle: window.productHandle
      };
    }
    
    return null;
  }

  async function checkProductInventory() {
    const config = getConfig();
    if (!config || !config.storefrontAccessToken || !config.handle) {
      console.warn('Missing config, storefrontAccessToken, or handle. Skipping inventory check.');
      return;
    }
    
    const STOREFRONT_ACCESS_TOKEN = config.storefrontAccessToken;
    // Use relative URL path - works on any domain including localhost
    const url = `/api/2024-07/graphql.json`;
    const handle = config.handle;
    
    const query = `
      query MyQuery($handle: String!) {
        product(handle: $handle) {
          id
          title
          availableForSale
          variants(first: 250) {
            nodes {
              quantityAvailable
            }
          }
          metafield(namespace: "custom", key: "acu_product_allow_back_order") {
            value
          }
        }
      }
    `;
    
    function waitForButton(maxAttempts = 50, interval = 100) {
      return new Promise((resolve) => {
        let attempts = 0;
        const checkButton = () => {
          const button = document.querySelector('.product-form__add-button');
          if (button || attempts >= maxAttempts) {
            resolve(button);
          } else {
            attempts++;
            setTimeout(checkButton, interval);
          }
        };
        checkButton();
      });
    }
    
    try {
      await waitForButton();
      
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
        },
        body: JSON.stringify({ 
          query,
          variables: { handle: handle }
        })      
      });
      
      const result = await response.json();
      
      if (result.errors) {
        console.error('GraphQL errors:', result.errors);
        return;
      } else if (result.data && result.data.product) {
        const productData = result.data.product;
        const totalInventory = productData.variants.nodes.reduce((sum, variant) => {
          return sum + (variant.quantityAvailable || 0);
        }, 0);
        
        window.productTotalInventoryFromGraphQL = totalInventory;

        const hasZeroStockAndContinuesSelling = productData.variants.nodes && productData.variants.nodes.some(variant => {
          return variant.quantityAvailable <= 0 && productData.availableForSale;
        });
        const metafieldEnabled = productData.metafield && productData.metafield.value === "true";
        const isBackOrder = hasZeroStockAndContinuesSelling && metafieldEnabled;
        
        function updateButtonState() {
          const button = document.querySelector('.product-form__add-button');
          if (!button) return;
          
          // Don't overwrite if button is already set to "Back Order" by another script
          const buttonText = button.innerText.trim().toLowerCase();
          if (buttonText === 'back order' || buttonText === 'pre order') {
            return;
          }
          
          if (totalInventory <= 0 && !isBackOrder) {
            // Update to Sold Out
            const soldOutLabel = (typeof window.soldOutText !== 'undefined') ? window.soldOutText : 'Sold Out';
            button.innerText = soldOutLabel;
            button.classList.add('button--disabled');
            button.disabled = true;
            button.removeAttribute('data-action');
            button.type = 'button';
            
            const stockAvailability = document.getElementById('product-form-stock');
            if (stockAvailability) {
              const currentText = stockAvailability.textContent.trim();
              const backOrderMessage = document.getElementById('back_order_availability_message');
              const isBackOrderMessage = backOrderMessage && currentText === backOrderMessage.value;
              
              if (!isBackOrderMessage) {
                const soldOutText = (typeof window.soldOutText !== 'undefined') ? window.soldOutText : 'Sold Out';
                stockAvailability.innerText = soldOutText;
                stockAvailability.classList.remove('inventory--high');
                stockAvailability.classList.add('inventory--low');
              }
            }
            
            const pickupDetailsDiv = document.querySelector('.store-pickup-details');
            if (pickupDetailsDiv) {
              pickupDetailsDiv.style.display = 'none';
            }
            
            const pickupDetailsLink = document.querySelector('.store-availability-container');
            if (pickupDetailsLink) {
              pickupDetailsLink.style.display = 'none';
            }
          } else if (totalInventory > 0 && button.disabled && button.classList.contains('button--disabled')) {
            // Restore Add to Cart if inventory is available
            const addToCartLabel = (typeof window.addToCartText !== 'undefined') ? window.addToCartText : 'Add to cart';
            button.innerText = addToCartLabel;
            button.classList.remove('button--disabled');
            button.disabled = false;
            button.setAttribute('data-action', 'add-to-cart');
            button.type = 'submit';
            
            const stockAvailability = document.getElementById('product-form-stock');
            if (stockAvailability) {
              stockAvailability.classList.remove('inventory--low');
              stockAvailability.classList.add('inventory--high');
            }
          }
        }
        
        // Update button state immediately and after a short delay to handle race conditions
        updateButtonState();
        setTimeout(updateButtonState, 200);
        setTimeout(updateButtonState, 500);
      } else if (result.data && result.data.product === null) {
        console.warn('Product not found for handle:', handle);
      } else {
        console.warn('Unexpected response format:', result);
      }
    } catch (error) {
      console.error('Error checking product inventory:', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkProductInventory);
  } else {
    checkProductInventory();
  }
})();
